// Optional chat profanity filter (display-side). Curated to strong
// "R-rated" language and slurs only — mild exclamations (damn, hell,
// piss, crap) intentionally pass through, per the moderation policy.
// Matched words are replaced with a random run of symbols so the
// rhythm of the sentence survives.
//
// The list is checked word-boundary, case-insensitively, with simple
// suffix coverage (s / es / ed / ing / er / ers). Display-side
// filtering means the original text stays intact on the server and
// for players who turn the filter off.

const STRONG_WORDS = [
  // f-family
  'fuck', 'fucker', 'fuckers', 'fucking', 'fucked', 'motherfucker', 'motherfucking', 'fck', 'fuk',
  // s-family
  'shit', 'shitty', 'bullshit', 'horseshit', 'shithead', 'shitting',
  // anatomy + sexual
  'cunt', 'cock', 'dick', 'dickhead', 'pussy', 'twat', 'tits', 'titties',
  'blowjob', 'handjob', 'jizz', 'cum', 'cumshot', 'dildo', 'rimjob', 'gangbang',
  // insults
  'bitch', 'bitches', 'asshole', 'assholes', 'bastard', 'whore', 'slut', 'sluts',
  'wanker', 'prick', 'douchebag',
  // slurs — always strong, no exceptions
  'nigger', 'nigga', 'niggas', 'faggot', 'fag', 'fags', 'retard', 'retarded',
  'tranny', 'dyke', 'kike', 'spic', 'chink', 'gook', 'wetback', 'beaner', 'coon',
];

const SYMBOLS = '@&^$%!#*';

const PATTERN = new RegExp(
  `\\b(${STRONG_WORDS.join('|')})(s|es|ed|ing|er|ers)?\\b`,
  'gi',
);

function scramble(len: number): string {
  let out = '';
  for (let i = 0; i < len; i++) {
    out += SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)];
  }
  return out;
}

/** Replace strong profanity with random symbol runs of the same length. */
export function filterProfanity(text: string): string {
  return text.replace(PATTERN, (match) => scramble(match.length));
}
